module.exports = __webpack_public_path__ + "media/images/twiter-53acaefd55b4f6894ffbd351aa93e478.png";